import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
// import HowTo from '@/LearnMore/HowTo.vue';
import Blog from '@/Blogs/blogListing.vue';
import BlogDetails from '@/Blogs/blogDetails.vue';
import VueEllipseProgress from 'vue-ellipse-progress';
import FAQS from '@/Faq/faqs.vue';
import Landing from '@/Landing.vue';
import Login from '@/Login.vue';
import 'bulma/css/bulma.css';
import 'bulma-helpers/css/bulma-helpers.min.css';
import vueScrollto from 'vue-scrollto';
import Vue2Filters from 'vue2-filters';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import { domain, clientId } from "../auth_config.json";
import { Auth0Plugin } from "./auth";

import Toasted from 'vue-toasted';
import VueCookies from 'vue-cookies'

Vue.use(vueScrollto)
Vue.use(VueCookies, { expires: '7d', path: '/', domain: '.spendid.io'})
// Vue.use(VueCookies, { expires: '7d', path: '/' })

// import 'bulma-tooltip/dist/css/bulma-tooltip.min.css'

import VTooltip from 'v-tooltip'

Vue.use(Vue2Filters)
Vue.use(VTooltip)
Vue.use(Toasted)
Vue.use(VueRouter)

// Import Bootstrap an BootstrapVue CSS files (order is important)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
Vue.use(VueEllipseProgress);

import money from 'v-money'

// register directive v-money and component <money>
Vue.use(money, { precision: 0 })

import axios from 'axios'

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});


Vue.prototype.$http = axios;

Vue.config.productionTip = false

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.eventSetDrag = function () {
      el.setAttribute('data-dragging', 'yes');
    }
    el.eventClearDrag = function () {
      el.removeAttribute('data-dragging');
    }
    el.eventOnClick = function (event) {
      var dragging = el.getAttribute('data-dragging');
      // Check that the click was outside the el and its children, and wasn't a drag
      if (!(el == event.target || el.contains(event.target)) && !dragging) {
        // call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.addEventListener('touchstart', el.eventClearDrag);
    document.addEventListener('touchmove', el.eventSetDrag);
    document.addEventListener('click', el.eventOnClick);
    document.addEventListener('touchend', el.eventOnClick);
  }, unbind: function (el) {
    document.removeEventListener('touchstart', el.eventClearDrag);
    document.removeEventListener('touchmove', el.eventSetDrag);
    document.removeEventListener('click', el.eventOnClick);
    document.removeEventListener('touchend', el.eventOnClick);
    el.removeAttribute('data-dragging');
  },

});

Vue.directive('click-outsides', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

const routes = [
  { path: '/', component: Landing },
  { path: '/login', component: Login },
  { path: '/blog-listing', component: Blog },
  { path: '/blog-details', component: BlogDetails },
  { path: '/faqs', component: FAQS },
]

const router = new VueRouter({
  mode: 'history',
  routes // short for `routes: routes`
})

new Vue({ el: '#app', router, render: h => h(App) })
